module.exports = __webpack_public_path__ + "static/img/advantage4.7b2dced.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/advantage4.webp
// module id = CUu2
// module chunks = 2